import './globalThis';
import './eventTarget';
import './abortController';
import './queueMicrotask';
import './flatMap';
